module.exports = __webpack_public_path__ + "static/media/AIR_AMS_COMPLEMENTARY_INFORMATION_GUIDE.58e43b1c.xlsx";